var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79779 1.91534L1.85225 1.85225C2.05195 1.65255 2.36445 1.6344 2.58466 1.79779L2.64775 1.85225L6 5.20425L9.35225 1.85225C9.57192 1.63258 9.92808 1.63258 10.1477 1.85225C10.3674 2.07192 10.3674 2.42808 10.1477 2.64775L6.79575 6L10.1477 9.35225C10.3474 9.55195 10.3656 9.86445 10.2022 10.0847L10.1477 10.1477C9.94805 10.3474 9.63555 10.3656 9.41534 10.2022L9.35225 10.1477L6 6.79575L2.64775 10.1477C2.42808 10.3674 2.07192 10.3674 1.85225 10.1477C1.63258 9.92808 1.63258 9.57192 1.85225 9.35225L5.20425 6L1.85225 2.64775C1.65255 2.44805 1.6344 2.13555 1.79779 1.91534L1.85225 1.85225L1.79779 1.91534Z",
    fill: "#CDCEC8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.7df2f9e7.svg";
export { ForwardRef as ReactComponent };